import { ProductViewConfigurator } from '~/types/configurator';

let label;
let description;

export default {
    controls: [
        {
            key: 'material',
            keyLabel: 'material',
            label: 'Label Material',
            choices: [
                {
                    label: (label = 'White'),
                    detailsModalLabel: label,
                    value: 'white',
                    description: (description =
                        'A traditional bright white material that lets your colors pop and your brand shine. Offered with a matte or gloss finish.'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'Metallic'),
                    detailsModalLabel: label,
                    value: 'metallic',
                    description: (description =
                        'Prefer the look of the metal can? This material allows metallic effects to shine in any area not covered by a layer of white ink. Matte or gloss finish.'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Material options:',
        },
        {
            key: 'finish',
            keyLabel: 'finish',
            label: 'Finish',
            choices: [
                {
                    label: (label = 'Matte'),
                    detailsModalLabel: label,
                    value: 'matte',
                    description: (description =
                        'If you prefer a more satin finish with a softer touch, we suggest matte. A more sophisticated look for your brand.'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'Gloss'),
                    detailsModalLabel: label,
                    value: 'gloss',
                    description: (description =
                        'Gloss is a bright, shiny finish for an extra boost to make your colors really pop.'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Finish options:',
        },
        {
            key: 'size',
            keyLabel: 'size',
            label: 'Size',
            choices: [
                {
                    label: (label = 'Slim - 3.25” × 7”'),
                    detailsModalLabel: label,
                    value: '3.25-x-7',
                },
                {
                    label: (label = 'Standard - 3.625” × 8”'),
                    detailsModalLabel: label,
                    value: '3.625-x-8',
                },
                {
                    label: (label = 'Sleek - 5.25” × 7”'),
                    detailsModalLabel: label,
                    value: '5.25-x-7',
                },
            ],
            modalComponent: 'BeverageLabelSizeModal',
        },
    ],
} as ProductViewConfigurator;
